var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalling2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10158_5012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0474 19.1811C21.1 18.2458 19.9172 18.2458 18.9758 19.1811C18.2577 19.8932 17.5395 20.6053 16.8335 21.3295C16.6404 21.5286 16.4774 21.5708 16.2421 21.4381C15.7774 21.1846 15.2826 20.9795 14.836 20.7019C12.7541 19.3923 11.0101 17.7087 9.46521 15.8138C8.69881 14.8724 8.0169 13.8646 7.54016 12.7301C7.44361 12.5008 7.46171 12.3499 7.64878 12.1629C8.3669 11.4689 9.06692 10.7568 9.77297 10.0447C10.7566 9.055 10.7566 7.89635 9.76694 6.90064C9.20572 6.33338 8.6445 5.7782 8.08328 5.21094C7.50395 4.63162 6.93066 4.04626 6.3453 3.47297C5.39787 2.54967 4.21508 2.54967 3.27368 3.47901C2.54952 4.19109 1.85554 4.92128 1.11932 5.6213C0.437406 6.267 0.0934319 7.05754 0.0210163 7.98084C-0.0936416 9.48346 0.274471 10.9016 0.793449 12.2836C1.85554 15.144 3.47282 17.6845 5.43408 20.0139C8.08328 23.164 11.2454 25.6563 14.9446 27.4546C16.6102 28.2632 18.3361 28.8848 20.2129 28.9874C21.5043 29.0598 22.6267 28.7339 23.5259 27.7262C24.1414 27.0382 24.8354 26.4106 25.4871 25.7528C26.4527 24.7752 26.4587 23.5924 25.4992 22.6269C24.3526 21.4743 23.2 20.3277 22.0474 19.1811Z",
    fill: "#673ee5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8931 14.3781L23.1199 13.9979C22.7699 11.9522 21.8043 10.0996 20.3379 8.62711C18.787 7.07621 16.8258 6.09861 14.6654 5.79688L14.3516 8.03573C16.0232 8.27108 17.5439 9.02539 18.7448 10.2263C19.8793 11.3608 20.6215 12.797 20.8931 14.3781Z",
    fill: "#673ee5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3763 4.69494C21.8055 2.12419 18.5528 0.500874 14.9622 0L14.6484 2.23885C17.7502 2.67334 20.5624 4.07941 22.7831 6.29412C24.8892 8.4002 26.2711 11.0615 26.772 13.9883L28.9988 13.6081C28.4134 10.2166 26.8142 7.13896 24.3763 4.69494Z",
    fill: "#673ee5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10158_5012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalling2);
export default __webpack_public_path__ + "static/media/icon_calling_2.356d7997916a1c9109cfaefba7be6639.svg";
export { ForwardRef as ReactComponent };